<template>
  <div class="footer">
    <div class="footer-main">
      <div class="logo-box">
        <router-link to="/">
          <img class="footer-logo" src="~@/assets/images/footerLogo.png" />
        </router-link>
        <img class="footer-logo" src="~@/assets/images/logo2.png" />
      </div>
      <div class="footer-text">
        <p>Zenifun Technology Limited All Rights Reserved.©GameSamba</p>
        <router-link to="/privacy">{{
          languagesData["footer"].privacy
        }}</router-link>
        |
        <router-link to="/company">{{
          languagesData["footer"].contact
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      data: "",
    };
  },
  computed: {
    ...mapState(["languages", "languagesData"]), // 在这里引入你需要的state值
  },
};
</script>

<style scoped>
.footer {
  height: 180px;
  box-sizing: border-box;
}
.footer-main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: #333;
  text-align: center;
  box-sizing: border-box;
  position: relative;
}

.footer-main .logo-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-main .footer-text,
.footer-main .footer-text a {
  color: #ffffff;
  font-size: 20px;
  text-align: left;
}
.footer-text {
  margin-left: 50px;
  color: #ffffff;
  font-size: 20px;
}
.footer-logo {
  display: block;
  max-width: 173px;
}

@media screen and (max-width: 1000px) {
  .footer {
    height: auto;
  }
  .footer-main {
    display: block;
    padding: 2% 0;
  }
  .footer-text {
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue